/**
 * lsnNg
 *  Moduł definiujący globalne funkcje JS używające Angulara
 */
angular.module('lsnNg', []);